module.exports = __webpack_public_path__ + "static/media/Buyer.601e09fc.png";